// @flow
import React from 'react';
import type { Node } from 'react';
import styled, { type StyledComponent } from 'styled-components';

import { textStyles, type TextSizes } from '@rover/design-system/style-dictionary/build/es6/theme';

import {
  margin,
  type MarginProps,
  textAlign,
  type TextAlignProps,
  textColor,
  type TextColorProps,
  fontWeight,
  type FontWeightProps,
  textTransform,
  type TextTransformProps,
  textDecoration,
  type TextDecorationProps,
} from '@rover/react-lib/styles/styled-system';

type TextNodes = 'span' | 'div' | 'label' | 'legend' | 'caption';

export type Props = {
  ...MarginProps,
  ...TextAlignProps,
  ...TextColorProps,
  ...FontWeightProps,
  ...TextTransformProps,
  ...TextDecorationProps,
  as: TextNodes,
  size: TextSizes,
  children: Node,
};

const StyledText: StyledComponent<Props> = styled.span`
  padding: 0;
  margin: 0;
  border: 0;
  ${({ size }) => textStyles[size]}
  ${margin}
  ${textAlign}
  ${textColor}
  ${fontWeight}
  ${textTransform}
  ${textDecoration}
`;

const Text = (props: Props) => <StyledText {...props} />;

Text.defaultProps = {
  as: 'span',
  size: '200',
};

export default Text;



// WEBPACK FOOTER //
// ../react-lib/src/components/typography/Text/Text.jsx